import React, { useMemo } from 'react';
import FilterDropdown from '../Filter/components/FilterDropdown';
import { translate } from '../../services/translate';
import { StyleProp, TextStyle } from 'react-native';
import { ApplicationStatus } from '../../schemas/deac';


interface Props {
    value: ApplicationStatus | 'all';
    setValue: React.Dispatch<React.SetStateAction<ApplicationStatus | 'all'>>;
    zIndex: number;
    labelStyle?: StyleProp<TextStyle>;
    viewStyle?: StyleProp<TextStyle>;
}

function ApplicationsStatusDropdown({ value, setValue, zIndex, labelStyle, viewStyle }: Props) {
    const items = useMemo(() => [
        { label: 'all', value: 'all' },
        { label: 'approved_singular', value: 'approved' },
        { label: 'confirmed_f', value: 'confirmed' },
        { label: 'progress', value: 'progress' },
        { label: 'finished_f', value: 'finished' },
        { label: 'canceled', value: 'canceled' },
    ].map(situation => {
        return { label: translate(situation.label), value: situation.value };
    }), []);

    return (
        <FilterDropdown
            label={translate('status')}
            items={items}
            multiple={false}
            setValue={setValue}
            value={value}
            zIndex={zIndex}
            labelStyle={labelStyle}
            viewStyle={viewStyle}
        />
    );
}

export default ApplicationsStatusDropdown;
